(() => {
  'use strict';
  let pending = false;
  async function update(row, quantity) {
    if (pending) return;
    pending = true;
    const cart = document.querySelector('cart-items');
    cart?.disableCartButtons?.();
    try {
      const base = window.Shopify?.routes?.root || '/';
      const current = await fetch(`${base}cart.js`, {headers: {Accept: 'application/json'}});
      if (!current.ok) throw Error('Your basket could not be checked. Please try again.');
      const state = await current.json();
      const updates = window.OrliPersonalisationCommerce.quantityUpdates(state.items, row.dataset.orliNativeGroup, quantity);
      const response = await fetch(window.theme.routes.cart_update_url, {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({updates})
      });
      const result = await response.json();
      if (!response.ok || result.errors || result.status) throw Error('Your basket could not be updated. Please try again.');
      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    } catch (error) {
      let status = row.querySelector('[data-orli-native-error]');
      if (!status) {
        status = document.createElement('p'); status.dataset.orliNativeError = ''; status.setAttribute('role', 'alert'); row.append(status);
      }
      status.textContent = error.message;
      cart?.enableCartButtons?.();
    } finally { pending = false; }
  }
  document.addEventListener('theme:cart:update', event => {
    const row = event.target.closest('[data-orli-native-group]');
    if (!row) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (row.dataset.orliNativeRole === 'parent') update(row, Number(event.detail.quantity));
  }, true);
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-item-remove]');
    const row = remove?.closest('[data-orli-native-group]');
    if (!row) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (row.dataset.orliNativeRole === 'parent') update(row, 0);
  }, true);
})();
